import merge from 'deepmerge';

import common from 'common/i18n/common';
import general from './general';
import campaign from '../modules/campaign/i18n/campaign';
import dashboard from '../modules/dashboard/i18n/dashboard';
import registration from '../modules/registration/i18n/registration';
import promotions from '../modules/promotions/i18n/promotions';
import userProfile from '../modules/userProfile/i18n/userProfile';
import proposition from '../modules/propositions/i18n/proposition';
import signup from '../modules/signup/i18n/signup';
import tutorials from '../modules/tutorials/i18n/tutorials';

export default merge.all([
  common,
  signup,
  general,
  campaign,
  dashboard,
  registration,
  promotions,
  userProfile,
  proposition,
  tutorials,
]);



// WEBPACK FOOTER //
// ./src/advertisers/i18n/translations.js